import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";

export const useFamilyPayments = ({
  page = 1,
  rows = 10,
  patientId,
  dueDateFrom,
  dueDateTo,
  paymentStatus,
  enabled = true,
  refetchOnWindowFocus = true
} = {}) => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  const currentPatientId = useCurrentPatientId();
  const finalPatientId = patientId || currentPatientId;

  return useQuery({
    queryKey: ["familyPayments", finalPatientId, tenantVal, page, rows, dueDateFrom, dueDateTo, paymentStatus],
    queryFn: async () => {
      if (!finalPatientId || !tenantVal) return null;
      const axiosInstance = await createAxiosInstance();
      
      const params = new URLSearchParams({
        page: page.toString(),
        rows: rows.toString()
      });

      if (dueDateFrom) params.append('dueDateFrom', dueDateFrom);
      if (dueDateTo) params.append('dueDateTo', dueDateTo);
      if (paymentStatus) params.append('paymentStatus', paymentStatus);

      const response = await axiosInstance.get(
        `${tenantVal}/consultationpaymentdue/getpatientid/${finalPatientId}/family/paginated?${params.toString()}`
      );
      return response.data;
    },
    enabled: enabled && !!finalPatientId && !!tenantVal,
    refetchOnWindowFocus,
    meta: { skipGlobalError: true },
  });
};
